import React from 'react';

const LevelSelect = props => {
  const { level, handleChange } = props;
  return (
    <select
      className="form-control btn-cursor"
      name="level"
      onChange={handleChange}
      value={level}
      data-qa-id="onboard-language-level"
      required
    >
      <option value="">Select your level</option>
      <option value="A1">Zero Knowledge</option>
      <option value="A2">Basic</option>
      <option value="B1">Intermediate</option>
      <option value="B2">Upper Intermediate</option>
      <option value="C1">Advanced</option>
      <option value="C2">Mastery</option>
    </select>
  );
};

export default LevelSelect;



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/LanguageProfile/LevelSelect/index.js